/** Messages invité (sans jargon technique). */

export function getGuestAuthIssueCopy(reason) {
  if (reason === 'no_auth_session') {
    return {
      title: 'Connexion invité temporairement indisponible',
      body: 'Tu peux quand même entrer sur la soirée. Pour retrouver un compte plus tard, connecte-toi par e-mail.',
    };
  }
  if (reason === 'bar_user_failed') {
    return {
      title: 'Profil soirée non créé',
      body: 'Tu peux participer en invité. Réessaie la connexion ou utilise un lien e-mail pour stabiliser ton compte.',
    };
  }
  return {
    title: 'Connexion limitée',
    body: 'Tu peux entrer sur la soirée en invité pendant que le service se rétablit.',
  };
}

export function formatEventLoadError(error) {
  if (!error) {
    return 'Impossible de charger la soirée. Réessaie dans un instant.';
  }
  const text = String(error);
  if (/fetch|network|failed to fetch/i.test(text)) {
    return 'Connexion impossible. Vérifie ton réseau puis recharge la page.';
  }
  if (/not found|404|introuvable/i.test(text)) {
    return 'Ce QR code ne correspond à aucune soirée active.';
  }
  if (import.meta.env.DEV) {
    return `Problème technique : ${text}`;
  }
  return 'Impossible de charger la soirée. Réessaie ou rescane le QR du bar.';
}

/** Traduit les erreurs d'auth Supabase (anglais) en messages FR pour l'invité/pro. */
export function mapAuthError(error) {
  const text = String(error?.message ?? error ?? '').toLowerCase();
  if (/invalid login credentials/.test(text)) return 'E-mail ou mot de passe incorrect.';
  if (/email not confirmed/.test(text)) return 'Confirme ton e-mail avant de te connecter (vérifie tes mails).';
  if (/user already registered|already been registered/.test(text))
    return 'Un compte existe déjà avec cet e-mail. Connecte-toi.';
  if (/password should be at least|password.*6 char/.test(text))
    return 'Mot de passe trop court (8 caractères minimum).';
  if (/rate limit|too many requests/.test(text))
    return 'Trop de tentatives. Patiente un instant puis réessaie.';
  if (/network|failed to fetch/.test(text))
    return 'Connexion impossible. Vérifie ton réseau puis réessaie.';
  if (import.meta.env.DEV) return `Erreur : ${error?.message ?? error}`;
  return 'Connexion impossible pour le moment. Réessaie.';
}

/** Infobulle courte pour la priorité (onglet Règles = détail). */
export const PRIORITY_FILE_HINT =
  'Ordre relatif : votes, réactions et montants. Ce n’est pas une garantie de passage. Détails dans l’onglet Règles.';

/**
 * Indice lisible pour la barre de priorité (sans % affiché).
 * Les percents sont des PARTS relatives (somme ~100) : avec beaucoup de titres,
 * même le 1er reste bas en absolu. On normalise donc par le meilleur du moment
 * pour que le leader soit « Élevée » et les autres proportionnels à lui.
 */
export function priorityTier(percent, maxPercent) {
  const pct = Math.min(100, Math.max(0, Number(percent) || 0));
  const max = Math.max(pct, Number(maxPercent) || 0);
  const rel = max > 0 ? (pct / max) * 100 : 0;
  if (rel >= 66) return { label: 'Élevée', width: rel };
  if (rel >= 33) return { label: 'Moyenne', width: rel };
  return { label: 'Faible', width: rel };
}
